import { render } from "./PendingOffer.vue?vue&type=template&id=15014221&scoped=true"
import script from "./PendingOffer.vue?vue&type=script&lang=js"
export * from "./PendingOffer.vue?vue&type=script&lang=js"

import "./PendingOffer.vue?vue&type=style&index=0&id=15014221&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15014221"

export default script